import { Platzhalter } from '@/components/ui/Platzhalter';

export function ReviewPage() {
  return (
    <Platzhalter
      titel="Review"
      beschreibung="Der Monatsabschluss zur BWA: was die Kanzlei gebucht hat und was noch zu klären ist."
      abschnitt="Phase 1.5, nach der ersten echten BWA"
    />
  );
}
